/**
 * Boxing Day Sale - 20% off for one-time purchases
 * Applies to products with data-boxing-day-sale="true" attribute
 * Works on both PLP (product cards) and PDP (product detail pages)
 */
(function() {
  'use strict';

  const DISCOUNT = 0.20; // 20% off

  // Calculate sale price
  function calculateSalePrice(originalPrice) {
    const numericPrice = parseFloat(originalPrice.replace(/[^0-9.]/g, ''));
    if (isNaN(numericPrice)) return originalPrice;

    const salePrice = Math.round(numericPrice * (1 - DISCOUNT) * 100) / 100;

    const currencyMatch = originalPrice.match(/^[^0-9]*/);
    const currency = currencyMatch ? currencyMatch[0] : '$';

    return currency + salePrice.toFixed(2);
  }

  // Update price display with sale format
  function updatePriceDisplay(priceElement, salePrice, originalPrice) {
    if (!priceElement) return;
    priceElement.innerHTML = `${salePrice} <del>${originalPrice}</del>`;
  }

  // Check if this is a Boxing Day product (PDP)
  function isBoxingDayPDP() {
    const mainProduct = document.querySelector('[id^="MainProduct-"][data-boxing-day-sale="true"]');
    if (mainProduct) return true;

    const priceContainer = document.querySelector('.price[data-boxing-day-sale="true"]');
    if (priceContainer) return true;

    return false;
  }

  // Apply sale pricing to all Boxing Day product cards (PLP)
  function applyPLPSalePricing() {
    const boxingDayCards = document.querySelectorAll('.card-wrapper[data-boxing-day-sale="true"]');

    boxingDayCards.forEach(function(card) {
      const priceEl = card.querySelector('.js-price');
      if (!priceEl) return;

      const selectedBtn = card.querySelector('.js--subscription-btn.selected');
      if (selectedBtn && selectedBtn.classList.contains('is-subscripton-btn')) {
        return;
      }

      const originalText = priceEl.textContent.trim();
      if (priceEl.querySelector('del')) return;

      const salePrice = calculateSalePrice(originalText);
      if (salePrice !== originalText) {
        updatePriceDisplay(priceEl, salePrice, originalText);
      }
    });
  }

  // Check if subscription is currently selected
  function isSubscriptionSelected() {
    const rcWidget = document.querySelector('.rc-widget');
    if (rcWidget) {
      const checkedOption = rcWidget.querySelector('[name="purchaseOption"]:checked');
      if (checkedOption && checkedOption.value === 'subscription') {
        return true;
      }
    }
    return false;
  }

  // Apply sale pricing to PDP (Product Detail Page)
  function applyPDPSalePricing() {
    if (!isBoxingDayPDP()) return;

    // Don't apply if subscription is selected
    if (isSubscriptionSelected()) return;

    // Find ALL price elements on PDP - including Recharge widget price-label
    // Only target the one-time option price-label, NOT the subscription one
    const priceSelectors = [
      '.rc-widget .onetime-radio .price-label',
      '.rca-product-price',
      '.js-price',
      '.price-item--regular',
      '.product-form__submit .price .price-item',
      '.rca-add-to-cart-submit .price .price-item'
    ];

    priceSelectors.forEach(function(selector) {
      const priceElements = document.querySelectorAll(selector);
      priceElements.forEach(function(priceEl) {
        const originalText = priceEl.textContent.trim();
        if (priceEl.querySelector('del')) return;
        if (!originalText || originalText.length < 2) return;

        const salePrice = calculateSalePrice(originalText);
        if (salePrice !== originalText) {
          updatePriceDisplay(priceEl, salePrice, originalText);
        }
      });
    });
  }

  // Hook into PLP one-time button clicks
  function setupPLPHandlers() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.js-one-time-btn');
      if (!btn) return;

      const card = btn.closest('.card-wrapper[data-boxing-day-sale="true"]');
      if (!card) return;

      setTimeout(function() {
        const priceEl = card.querySelector('.js-price, .price__regular .price-item--regular');
        if (!priceEl) return;
        if (priceEl.querySelector('del')) return;

        const currentText = priceEl.textContent.trim();
        const salePrice = calculateSalePrice(currentText);
        if (salePrice !== currentText) {
          updatePriceDisplay(priceEl, salePrice, currentText);
        }
      }, 50);
    });

    // Variant changes on PLP
    document.addEventListener('change', function(e) {
      const input = e.target.closest('.js-product-form__input input');
      if (!input) return;

      const card = input.closest('.card-wrapper[data-boxing-day-sale="true"]');
      if (!card) return;

      const selectedBtn = card.querySelector('.js--subscription-btn.selected');
      if (selectedBtn && selectedBtn.classList.contains('is-subscripton-btn')) {
        return;
      }

      setTimeout(function() {
        const priceEl = card.querySelector('.js-price, .price__regular .price-item--regular');
        if (!priceEl) return;
        if (priceEl.querySelector('del')) return;

        const currentText = priceEl.textContent.trim();
        const salePrice = calculateSalePrice(currentText);
        if (salePrice !== currentText) {
          updatePriceDisplay(priceEl, salePrice, currentText);
        }
      }, 100);
    });
  }

  // Hook into PDP Recharge widget for subscription/one-time toggle
  function setupPDPHandlers() {
    if (!isBoxingDayPDP()) return;

    let observer = null;
    let debounceTimer = null;

    // Debounced apply function to avoid rapid re-application
    function debouncedApply() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        if (!isSubscriptionSelected()) {
          applyPDPSalePricing();
        }
      }, 50);
    }

    // Watch for Recharge widget
    const checkForWidget = setInterval(function() {
      const rcWidget = document.querySelector('.rc-widget');
      if (!rcWidget) return;

      clearInterval(checkForWidget);

      // Listen for purchase option changes
      rcWidget.querySelectorAll('[name="purchaseOption"]').forEach(function(option) {
        option.addEventListener('click', function() {
          setTimeout(function() {
            if (option.value === 'subscription') {
              // Subscription - let original JS handle it
              return;
            } else {
              // One-time purchase - apply sale price
              applyPDPSalePricing();
            }
          }, 150);
        });
      });

      // Use MutationObserver to watch for price-label changes by Recharge
      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          // Check if price-label content was changed
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            // Only check the one-time price-label, not the subscription one
            const onetimeLabel = rcWidget.querySelector('.onetime-radio .price-label');
            if (onetimeLabel && !onetimeLabel.querySelector('del') && !isSubscriptionSelected()) {
              debouncedApply();
            }
          }
        });
      });

      observer.observe(rcWidget, {
        childList: true,
        subtree: true,
        characterData: true
      });

      // Apply initial sale price if one-time is selected or no selection yet
      const checkedOption = rcWidget.querySelector('[name="purchaseOption"]:checked');
      if (!checkedOption || checkedOption.value !== 'subscription') {
        setTimeout(applyPDPSalePricing, 100);
      }
    }, 100);

    // Stop checking after 5 seconds, but still try to apply
    setTimeout(function() {
      clearInterval(checkForWidget);
      applyPDPSalePricing();
    }, 5000);
  }

  // Initialize
  function init() {
    applyPLPSalePricing();
    setupPLPHandlers();

    // For PDP, wait a bit for Recharge to initialize
    if (document.body.classList.contains('template-name--product') || document.querySelector('[id^="MainProduct-"]')) {
      setTimeout(function() {
        applyPDPSalePricing();
        setupPDPHandlers();
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
